
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../FileFinder/FileFinderTypes";
import "../../moreCore/UI/Button/Button";

//import PropositionForm = require("../EmploymentProposition/EmploymentPropositionForm");
import EmploymentPropositionForm from './EmploymentPropositionForm';
import { EmploymentPropositionTypes } from "./OE_Types";
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import { WindowHelpers } from "../../more/Helpers";

//import "../EmploymentProposition/EmploymentPropositionTypes";
class OE_MusicianPropositionFinder extends compose(FinderBaseV2) {


    protected _tableLayouts: Array<StaticTable.Layout> = [{
        "name": "default",
        "label": "Default",
        rows: [{
            "attributes": [
                "ev_project_name",
                "ref_artistic_period.description",
                "date_from",
                "date_to",
                "",
                ""
            ],
            "colspans": [
                1,
                1,
                1,
                1,
                1,
                1
            ],
            "headings": [
                (this as any).translations["EmploymentProposition_TableColHead_ProjectName"],
                (this as any).translations["EmploymentProposition_TableColHead_ArtisticPeriod"],
                (this as any).translations["EmploymentProposition_TableColHead_DateFrom"],
                (this as any).translations["EmploymentProposition_TableColHead_DateTo"],
                (this as any).translations["EmploymentProposition_TableColHead_Proposition"],
                (this as any).translations["EmploymentProposition_TableColHead_ConfirmedProposition"],
            ],
            "colNamesInternal": [
                "project",
                "artisticPeriod",
                "date_from",
                "date_to",
                "proposition",
                "confirmedProp",
            ]
        }]
        
    }]

    table_Formatter(cell: StaticTable.StaticTableCell<EmploymentPropositionTypes.EvProjectWithProposition>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let index = cell.tableRow.lineIndex;
        let value = cell.value;
        switch (colName) {
            
            default:
                return false;
        }
    }
  

    private _onClick_Row(row: StaticTable.StaticTableRow<EmploymentPropositionTypes.EvProjectWithProposition>, rowGroup: StaticTable.StaticTableRowGroup<EmploymentPropositionTypes.EvProjectWithProposition>) {

        let entity = rowGroup.entity;

        this.openForm(entity);

    }

    openForm(entity: EmploymentPropositionTypes.EvProjectWithProposition) {
        if (!entity) return;


        let form = new EmploymentPropositionForm();
        
        form.setup(this.filterpanel.getFilterOptionByName("myEngagements")?.getValue().toString(), entity.ID);

        form.show("dlg", `${entity.ev_project_name} - ${this.translate("MusicianProposition_Label_RegistrationFor")} ${this.filterpanel.getFilterOptionByName("myEngagements").getValueLabel()}`, this.getTabContainerName());

        // Propositionform enthält bereits View mit Projekt etc
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinderWithCallfunctions(
            "Webtool_API_OrchestraEmploymentProposition__GetMusicianAgendaConfig",
            "Webtool_API_OrchestraEmploymentProposition__GetMusicianProjectList",
            lang.hitch(this, this._onClick_Row),
            null, // Standard-Formatter
            null,
        );


        WindowHelpers.setTitles("OrchestraEmploymentProposition_Label__Proposition");        

    }
    startup(): void {
        super.startup.apply(this, arguments as any);


    }
}

export default mdsWidget(OE_MusicianPropositionFinder);